const STATE_COLORS = {
  ENDED: undefined,
  HOURS_0_4: '#F0473C',
  HOURS_4_8: '#F36B43',
  HOURS_8_12: '#F39B31',
  HOURS_12_16: '#F3CE47',
  HOURS_16_20: '#64E543',
  HOURS_20_24: '#64E543',
  ACTIVE: undefined,
} as const

export type MintEndState = keyof typeof STATE_COLORS

export const getCountdownSegmentStyles = ({
  state,
  index,
  color,
}: {
  state: MintEndState
  index: number
  color: string
}) => {
  const foregroundColor = STATE_COLORS[state] ? STATE_COLORS[state] : color

  if (state === 'ENDED')
    return {
      fillOpacity: 0.3,
      fill: color,
    }

  const stateIndex = [
    'HOURS_0_4',
    'HOURS_4_8',
    'HOURS_8_12',
    'HOURS_12_16',
    'HOURS_16_20',
    'HOURS_20_24',
  ].indexOf(state)

  return {
    fillOpacity: index <= stateIndex ? 1 : 0.3,
    fill: index <= stateIndex ? foregroundColor : color,
  }
}
